<template>
  <div class="container">
    <div class="paper-page trans">
      <paper-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <div class="tools color" @click="handleClickDelivery">投稿须知</div>
        <div class="tools" @click="$router.push({ name: 'downloadPaper' })">
          下载模板
        </div>
        <div v-if="canSubmit" class="tools" @click="handleContribution">我要投稿</div>
        <div v-if="!canSubmit" class="disabled-tools">{{ changebtn }}</div>

        <div class="delivery-info">
          <h2 class="tit">投稿信息</h2>
          <div v-if='list.length>0' class="content">
            <div
              class="item"
              @click="getDetails(item)"
              v-for="(item, index) in list"
              :key="index"
            >
              <p class="sub"><span>论文编号:</span>{{ item.id }}</p>
              <p class="sub"><span>题目:</span> {{ item.title }}</p>
              <p class="sub"><span>作者:</span> {{ item.authorname }}</p>
              <p class="sub"><span>状态:</span> {{ item.status }}<span style="color: #999;;" v-if="item.status=='修改稿件' && item.ismodified">(已修改)</span></p>
              <p v-if="(item.status=='退稿' || item.status=='录用'|| item.status=='修改稿件') && item.actions.length>0 && item.actions[0].reason" class="sub"><span>意见:</span> {{ item.actions[0].reason}}</p>
              <!-- <p style="font-size: 15px;margin-top:8px">我们会将录用的论文推荐到《土木工程学报》</p> -->
            </div>
          </div>
          <div class="content" v-else>您没有投稿信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import paperHeader from "@/components/header"
  import { Contributions } from "@/store/entity/contributions"
  import CurrentConferMixin from "@/mixin/CurrentConference"
  import CurrentUserMixin from "@/mixin/CurrentUser"
  export default {
    name: "paperPage",
    components: {
      paperHeader,
    },
    mixins: [CurrentConferMixin, CurrentUserMixin],
    data() {
      return {
        list: [],
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "论文投稿",
        },
      }
    },
    computed: {
      readyData() {
        // 当会议和当前用户都有全局值后才通过
        if (this.currentConference.id > 0 && this.currentUser.id > 0) {
          return {
            conference_id: this.currentConference.id,
            current_user_id: this.currentUser.id,
          }
        } else {
          return null
        }
      },
      changebtn(){
        let d1 =new Date().getTime()
        let d2 = new Date(this.currentConference.submissiondeadline).getTime()
        let d3 = new Date(this.currentConference.submissionstart).getTime()
        if(d1<d3){
          return "投稿未开始"
        }
        console.log(d1>d2)
        if(d1>d2){
          return "投稿结束"
        }
      },
      canSubmit(){
        if(this.currentConference.submissionstart && this.currentConference.submissiondeadline){//配置了投稿开始和截止日期
        let d1 =new Date().getTime()
        let d2 = new Date(this.currentConference.submissiondeadline).getTime()
        let d3 = new Date(this.currentConference.submissionstart).getTime()
        if(d1<d3){
          return false;
        }
        if(d1>d2){//到了截止日期
          //到了投稿截止日期之后
          false;
        }else{//未到截止日期
          return true;
        }
      }else{//未配置投稿开始或截止日期
        return false;
      }
    }
    },
    created() {
      if (this.readyData) {
        this.getContributionsList()
      }
    },
    watch: {
      readyData: {
        handler() {
          this.getContributionsList()
        },
      },
      deep: true,
    },
    methods: {
      getContributionsList() {
        if (this.readyData == null) {
          return
        }
        let ids = {}
        ids = Contributions.getList({
          per_page: -1,
          conference_id: this.readyData.conference_id,
          created_by_id: this.readyData.current_user_id,
          order_by_desc:'id'
        }).then((data) => {
          this.list = data.result
          debugger
          console.log(this.list)
        })
      },
      handleClickIocn() {
        this.$router.push("/")
        // history.go(-1)
      },
      handleClickDelivery() {
        this.$router.push("/needInfo")
      },
      // getDetails() {
      //     this.$router.push("/paperDetails");
      // },
      getDetails(item) {
        this.$router.push({ name: "paperDetails", params: { inform: item }, query:{paper_id: item.id} })
      },
      handleContribution() {
        this.$router.push("/contributions")
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    .disabled-tools{
      width: 100%;
      font-size: 16px;
      padding: 5px 15px;
      line-height: 40px;
      margin-top: 15px;
      border-radius: 8px;
      font-weight: bold;
      box-sizing: border-box;
      color: #A9A9A9;
      border: 1px solid #A9A9A9;

      &.color {
        color: #fff;
        background: var(--main-color);
      }
    }
    .tools {
      width: 100%;
      font-size: 16px;
      padding: 5px 15px;
      line-height: 40px;
      margin-top: 15px;
      border-radius: 8px;
      font-weight: bold;
      box-sizing: border-box;
      color: var(--main-color);
      border: 1px solid var(--main-color);

      &.color {
        color: #fff;
        background: var(--main-color);
      }
    }

    .delivery-info {
      margin-top: 30px;

      .tit {
        font-size: 16px;
        font-weight: bold;
        color: var(--main-color);
        padding-left: 5px;
        border-left: 3px solid var(--main-color);
      }

      .content {
        margin-top: 15px;

        .item {
          padding: 15px;
          border-radius: 5px;
          box-sizing: border-box;
          box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);

          .sub {
            color: #999;
            line-height: 25px;

            span {
              color: #424242;
            }
          }
        }
      }
    }
  }
</style>
